import { render, staticRenderFns } from "./ZhenDuan.vue?vue&type=template&id=7fac1802&scoped=true"
import script from "./ZhenDuan.vue?vue&type=script&lang=js"
export * from "./ZhenDuan.vue?vue&type=script&lang=js"
import style0 from "./ZhenDuan.vue?vue&type=style&index=0&id=7fac1802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac1802",
  null
  
)

export default component.exports